import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { auditBaseUrl, prjectMgm } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const kRAMasterService = createApi({
    reducerPath: 'kRAMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['KRAMaster'],
    endpoints: (builder) => ({
        getAllKRAMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.kRAMasterMasterController.getAllKRAMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getKRAMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.kRAMasterMasterController.getKRAMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveKRAMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.kRAMasterMasterController.saveKRAMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateKRAMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.kRAMasterMasterController.updateKRAMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteKRAMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.kRAMasterMasterController.deleteKRAMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllKRAMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.kRAMasterMasterController.getAllKRAMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllKRAMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.kRAMasterMasterController.findAllKRAMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllKRAMasterMutation,
    useSaveKRAMasterMutation,
    useUpdateKRAMasterMutation,
    useDeleteKRAMasterMutation,
    useGetKRAMasterByIdMutation,
    useGetAllKRAMasterWithSearchMutation,
    useFindAllKRAMasterMutation,
  } = kRAMasterService;